<template>
  <v-data-table
    :headers="header"
    :items="rows"
    :items-per-page="-1"
    :loading="loading"
    :hide-default-header="loading"
    hide-default-footer
    loading-text="Carregando ... por favor, aguarde."
    no-data-text="Nenhum registro disponível"
    mobile-breakpoint="0"
  >
    <template v-slot:item="row">
      <tr>
        <td>
          {{ row.item['medicao'] }}
        </td>
        <td class="texto">
          {{ row.item['periodo'].toLowerCase() }}
        </td>
        <td class="texto">
          {{ row.item['condicao'].toLowerCase() }}
        </td>
        <td>
          {{ row.item['aderencia'] }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: 'TabelaKpis',
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      rows: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        header: [
          {
            text: 'Medição',
            value: 'Medição',
            sortable: false
          },
          {
            text: 'Condição',
            value: 'Condição',
            sortable: false
          },
          {
            text: 'Período',
            value: 'Período',
            sortable: false
          },
          {
            text: 'Aderência',
            value: 'Aderência',
            sortable: false
          }
        ]
      };
    }
  };
</script>

<style scoped>
  .texto {
    text-transform: capitalize;
  }
</style>